module.exports = __webpack_public_path__ + "static/media/Desktop-inbox-1.1b197eaa.jpg";